module.exports = __webpack_public_path__ + "img/2.63c773c0.png";